import React from 'react';
import {Dialog, withStyles} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import {UserDialogContent} from "./UserDialogContent";
import {UserDialogModes} from "../../utils/users";
import {createUser, patchUser} from "../../redux/reducers/users-reducer";
import {useFormik} from "formik";
import * as yup from "yup";
import {useDispatch} from "react-redux";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});


const DialogTitle = withStyles(styles)(
    (props) => {
        const {children, classes, onClose, mode, getFieldProps, setFieldValue, ...other} = props;
        const {value} = getFieldProps('is_activated')

        const onIsActivatedChange = (e) => {
            setFieldValue('is_activated', e.target.checked)
        }
        return <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Grid container alignItems={"center"} spacing={2}>
                <Grid item>
                    <Typography variant="h6">{children}</Typography>

                </Grid>
                {mode === UserDialogModes.CHANGE ? <Grid item>
                    <FormGroup row>
                        <FormControlLabel
                            control={<Checkbox checked={value}
                                               onChange={onIsActivatedChange}
                                               name="is_activated"/>}
                            label="Активен"
                        />
                    </FormGroup>
                </Grid> : undefined}
            </Grid>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    }
)


export const UserDialog = ({open, handleClose, companies, contracts, user, mode}) => {
    const dispatch = useDispatch()

    const initialValues = {
        first_name: '',
        last_name: '',
        mid_name: '',
        organization: '',
        appointment: '',
        full_name: '',
        full_name_to_whom: '',
        full_name_by_whom: '',
        full_name_whom: '',
        appointment_to_whom: '',
        appointment_by_whom: '',
        appointment_whom: '',
        phone_number: '',
        email: '',
        username: '',
        password: '',
        confirm_password: '',
        role: '',
        contracts: []
    }

    const onSubmit = values => {
        if (mode === UserDialogModes.CREATE) {
            dispatch(createUser(values, handleClose))
        }
        if (mode === UserDialogModes.CHANGE) {
            dispatch(patchUser(values, handleClose))
        }
    }

    const {touched, errors, getFieldProps, setFieldValue, handleSubmit} = useFormik({
        initialValues: mode === UserDialogModes.CHANGE ? user : initialValues,
        validationSchema: yup.object().shape({
            first_name: yup.string().required('Необходимо заполнить'),
            last_name: yup.string().required('Необходимо заполнить'),
            mid_name: yup.string(),
            organization: yup.string().required('Необходимо заполнить'),
            appointment: yup.string().required('Необходимо заполнить'),
            full_name: yup.string(),
            full_name_to_whom: yup.string(),
            full_name_by_whom: yup.string(),
            full_name_whom: yup.string(),
            appointment_to_whom: yup.string(),
            appointment_by_whom: yup.string(),
            appointment_whom: yup.string(),
            phone_number: yup.string(),
            email: yup.string().required('Необходимо заполнить').email('Неверный формат e-mail'),
            username: yup.string().required('Необходимо заполнить'),
            password: mode === UserDialogModes.CREATE ? yup.string().required('Необходимо заполнить') : undefined,
            confirm_password: UserDialogModes.CREATE ? yup.string().required('Необходимо заполнить').oneOf([yup.ref('password'), null],
                'Пароли должны совпадать') : undefined,
            role: yup.string().required('Выберите из списка роль пользователя'),
            contracts: yup.array().min(1, 'Необходимо выбрать хотя бы 1 компанию или проект')
        }),
        onSubmit
    })

    return <Dialog onClose={handleClose} open={open} fullWidth maxWidth={"md"}>
        <DialogTitle onClose={handleClose} getFieldProps={getFieldProps} setFieldValue={setFieldValue} mode={mode}>
            {mode === UserDialogModes.CREATE ? 'Создание профиля' : 'Изменение профиля'}
        </DialogTitle>
        <DialogContent>
            <UserDialogContent mode={mode}
                               companies={companies}
                               contracts={contracts}
                               touched={touched}
                               errors={errors}
                               getFieldProps={getFieldProps}
                               setFieldValue={setFieldValue}
                               handleSubmit={handleSubmit}
            />
        </DialogContent>
    </Dialog>
}